import ImportScheduleAdapter from 'teacher-ui-client/adapters/import-schedule'

export default class ImportValidationAdapter extends ImportScheduleAdapter {
  pathForType(modelName: string) {
    return modelName // just the model name, not pluralised
  }
}
